import React, { useState } from 'react'
import get from 'lodash/get'
import ImageUploading, { ImageListType, ImageType } from 'react-images-uploading'

import PhotoSelector from 'components/PhotoSelector'
import StepButtons from '../../../../components/StepButtons'

const MAX_NUMBER_OF_PHOTOS = 5

type Props = {
  onClickSave: (updatedPhotos: any[]) => void
  propertyPhotos: ImageType[]
}

const PropertyPhotos = (props: Props) => {
  const [images, setImages] = useState<ImageListType>(props.propertyPhotos)

  const onChange = (imageList: ImageListType) => {
    setImages(imageList)
  }

  const handleSaveStep = () => {
    props.onClickSave(images)
  }

  return (
    <div style={styles.container}>
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={MAX_NUMBER_OF_PHOTOS}
        dataURLKey='dataURL'
        acceptType={['jpg', 'jpeg', 'png']}
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <>
            <PhotoSelector
              onAddPhoto={onImageUpload}
              onUpdatePhoto={() => onImageUpdate(0)}
              onRemovePhoto={() => onImageRemove(0)}
              photo={get(imageList[0], 'dataURL', '')}
              big
            />
            <div style={styles.rowContainer}>
              <PhotoSelector
                onAddPhoto={onImageUpload}
                onUpdatePhoto={() => onImageUpdate(1)}
                onRemovePhoto={() => onImageRemove(1)}
                photo={get(imageList[1], 'dataURL', '')}
              />
              <div style={styles.spacer} />
              <PhotoSelector
                onAddPhoto={onImageUpload}
                onUpdatePhoto={() => onImageUpdate(2)}
                onRemovePhoto={() => onImageRemove(2)}
                photo={get(imageList[2], 'dataURL', '')}
              />
            </div>
            <div style={styles.rowContainer}>
              <PhotoSelector
                onAddPhoto={onImageUpload}
                onUpdatePhoto={() => onImageUpdate(3)}
                onRemovePhoto={() => onImageRemove(3)}
                photo={get(imageList[3], 'dataURL', '')}
              />
              <div style={styles.spacer} />
              <PhotoSelector
                onAddPhoto={onImageUpload}
                onUpdatePhoto={() => onImageUpdate(4)}
                onRemovePhoto={() => onImageRemove(4)}
                photo={get(imageList[4], 'dataURL', '')}
              />
            </div>
          </>
        )}
      </ImageUploading>
      <StepButtons onPressNext={handleSaveStep} />
    </div>
  )
}

const styles = {
  container: {
    paddingRight: 20,
  },
  rowContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '16px 0',
  },
  spacer: {
    width: 16,
  },
}

export default PropertyPhotos
